import { Box, MenuItem, Select, Skeleton } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { setActiveProject, setActiveSprint } from '../../redux/sessionSlice';
import { useListProjectsQuery, useListSprintsQuery } from '../../redux/firestoreApi';
import { useEffect } from 'react';

export default function ProjectSprintSwitcher() {
  const dispatch = useAppDispatch();
  const uid = useAppSelector((s) => s.session.uid);
  const activeProjectId = useAppSelector((s) => s.session.activeProjectId);
  const activeSprintId = useAppSelector((s) => s.session.activeSprintId);

  const projects = useListProjectsQuery(uid ? { uid } : (undefined as any), {
    skip: !uid,
  });

  const sprints = useListSprintsQuery(
    uid && activeProjectId ? { uid, projectId: activeProjectId } : (undefined as any),
    { skip: !uid || !activeProjectId },
  );

  // Auto-select first project / sprint when nothing is chosen yet.
  useEffect(() => {
    if (!activeProjectId && projects.data && projects.data.length > 0) {
      dispatch(setActiveProject(projects.data[0].id));
    }
  }, [projects.data, activeProjectId, dispatch]);

  useEffect(() => {
    if (!activeSprintId && sprints.data && sprints.data.length > 0) {
      dispatch(setActiveSprint(sprints.data[0].id));
    }
  }, [sprints.data, activeSprintId, dispatch]);

  if (projects.isLoading) {
    return <Skeleton variant="rounded" width={220} height={36} />;
  }

  return (
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
      <Select
        size="small"
        displayEmpty
        value={activeProjectId ?? ''}
        onChange={(e) => dispatch(setActiveProject(e.target.value || null))}
        sx={{ minWidth: 180 }}
      >
        <MenuItem value="">
          <em>Select project…</em>
        </MenuItem>
        {projects.data?.map((p) => (
          <MenuItem key={p.id} value={p.id}>
            {p.projectCode} — {p.projectName}
          </MenuItem>
        ))}
      </Select>

      <Select
        size="small"
        displayEmpty
        value={activeSprintId ?? ''}
        onChange={(e) => dispatch(setActiveSprint(e.target.value || null))}
        sx={{ minWidth: 200 }}
        disabled={!activeProjectId}
      >
        <MenuItem value="">
          <em>Select sprint…</em>
        </MenuItem>
        {sprints.data?.map((s) => (
          <MenuItem key={s.id} value={s.id}>
            {s.sprintName}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
}
